import { SvgIcon, SvgIconProps } from '@mui/material';

export const RedCrossIcon = ({ fontSize, scale }: Pick<SvgIconProps, 'fontSize' | 'scale'>) => {
  return (
    <SvgIcon fontSize={fontSize || 'small'} sx={{ scale: scale ?? 1 }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20ZM6.29289 13.7071C5.90237 13.3166 5.90237 12.6834 6.29289 12.2929L8.58579 10L6.29299 7.70714C5.90246 7.31661 5.90246 6.68345 6.29299 6.29292C6.68351 5.9024 7.31668 5.9024 7.7072 6.29292L10 8.58579L12.2929 6.29289C12.6834 5.90237 13.3166 5.90237 13.7071 6.29289C14.0976 6.68342 14.0976 7.31658 13.7071 7.70711L11.4142 10L13.7072 12.2929C14.0977 12.6835 14.0977 13.3166 13.7072 13.7071C13.3167 14.0977 12.6835 14.0977 12.293 13.7071L10 11.4142L7.70711 13.7071C7.31658 14.0976 6.68342 14.0976 6.29289 13.7071Z"
          fill="#BF6E6E"
        />
      </svg>
    </SvgIcon>
  );
};
